import React from 'react';
import infoIcon from '../common/infoIcon';
import CalculatorAssumptionBox from './CalculatorAssumptionBox';

class CalculatorAssumptions extends React.Component {
  state = {
    shown: false,
  }
  handleShow = () => {
    document.body.classList.add("no-scroll")
    this.setState({
      shown: true
    })
  }
  handleDismiss = () => {
    document.body.classList.remove("no-scroll")
    this.setState({
      shown: false
    })
  }
  render() {
    const { isDreamSpace, text } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';
    const header = text ? text : <span><span>Calculator assumptions</span>{infoIcon(isDreamSpace)}</span>
    return(
      <div className="calculator-assumptions">
        <button className={`calculator-assumptions__link ${className}`} onClick={this.handleShow} >
          {header}
        </button>
        {this.state.shown ?
          <CalculatorAssumptionBox handleDismiss={this.handleDismiss}>
            {this.props.assumptionBoxContents}
          </CalculatorAssumptionBox> : null}
      </div>
    )
  }
}

export default CalculatorAssumptions;
